export default __webpack_public_path__ + "static/media/aisthisi-7.dc771828.gif";